/*
 * product.js — cart icon / overlay toggles and legacy cart-drawer quantity helpers.
 * PERF (P-01/P-02): rewritten without jQuery so jquery.min.js (89 KB) no longer
 * loads on every page. Behaviour is unchanged from the jQuery version.
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      bubble.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.add('cart-open');
      });
    }
    document.querySelectorAll('.overlay').forEach(function (el) {
      el.addEventListener('click', function () {
        document.body.classList.remove('cart-open');
      });
    });
  });

  function closeCart() {
    document.body.classList.remove('cart-open');
  }

  function replaceFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) current.replaceWith(fresh);
  }

  // Name kept (including the original spelling) in case inline handlers call it.
  function sectionRedering() {
    fetch('?section_id=cart-drawer-test')
      .then(function (res) { return res.text(); })
      .then(function (html) { replaceFrom(html, '.cart-drawer__inner'); })
      .catch(function () {});

    fetch('?section_id=header')
      .then(function (res) { return res.text(); })
      .then(function (html) { replaceFrom(html, '.cart-count-bubble'); })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart change failed');
      return res.json();
    });
  }

  function changeQuantity(input) {
    changeLine(input.getAttribute('data-line'), input.value)
      .then(sectionRedering)
      .catch(function () { console.log('Error from quantity update'); });
  }

  // increment quantity in cart drawer
  function increment(el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    input.value = value + 1;
    changeQuantity(input);
  }

  // decrement quantity in cart drawer
  function decrement(el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value, 10);
    if (value > 0) {
      input.value = value - 1;
      changeQuantity(input);
    }
  }

  function removeItem(event, el) {
    event.preventDefault();
    changeLine(el.getAttribute('data-line'), 0).then(sectionRedering).catch(function () {});
  }

  window.closeCart = closeCart;
  window.sectionRedering = sectionRedering;
  window.changeQuantity = changeQuantity;
  window.increment = increment;
  window.decrement = decrement;
  window.removeItem = removeItem;
})();
